<template>
  <v-card>
    <slot name="above-title" />
    <v-card-title> Invite client </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        @keyup.enter.native="invite()"
      >
        <v-text-field
          ref="email"
          v-model="email"
          :disabled="inviting"
          :rules="[validateRequired, ...emailRules]"
          label="Email"
          type="email"
          autofocus
          required
          @blur="emailDirty = true"
        />
        <v-text-field
          ref="name"
          v-model="name"
          :disabled="inviting"
          :rules="[validateRequired, ...nameRules]"
          label="Name"
          required
          @blur="nameDirty = true"
        />
        <v-alert
          text
          type="info"
        >
          New accounts will receive an email invitation to join Authentigate and
          be a client of yours. Existing accounts will receive an email
          invitation to be a client of yours.
        </v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="inviting"
        color="primary"
        text
        large
        @click.stop="$emit('cancel')"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!valid || !emailValid || !nameValid || inviting"
        :loading="inviting"
        color="primary"
        large
        @click.stop="invite()"
      >
        Invite
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'InviteClientForm',
  data: function () {
    return {
      inviting: false,
      valid: false,
      email: '',
      emailDirty: false,
      name: '',
      nameDirty: false,
      emailValidEmail: true
    }
  },
  computed: {
    emailRules() {
      var rules = []
      if (this.emailDirty && !this.emailValidEmail) {
        rules.push('Not a valid email address.')
      } else {
        rules.push(true)
      }
      return rules
    },
    nameRules() {
      var rules = []
      if (this.nameDirty && !this.nameValid) {
        rules.push('Please enter first, middle (if known), and last names.')
      } else {
        rules.push(true)
      }
      return rules
    },
    emailValid() {
      return this.emailValidEmail
    },
    nameValid() {
      return /\w\w+\s\S\w+/.test(this.name)
    }
  },
  watch: {
    email: function () {
      this.emailValidEmail = this.$refs.email.$refs.input.validity.valid
    }
  },
  methods: {
    validateRequired,
    reset() {
      this.$refs.form.reset()
      Object.assign(this.$data, this.$options.data())
    },
    invite() {
      const name = this.name
      const email = this.email
      this.inviting = true
      this.$handlingError(
        `Error inviting "${name}" (${email})`,
        async () => {
          await this.$api.inviteAsClient({ name, email })
          this.$emit('invited', { name, email })
          this.reset()
        },
        {
          final: () => {
            this.inviting = false
          }
        }
      )
    }
  }
}
</script>
